import React, { useEffect, useState } from 'react';
import { useData } from '../../../contexts';
import { DownloadButton } from '../../DownloadButton/DownloadButton';
// import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { Grid } from '@mui/material';
import { MdClose, MdHelpOutline } from 'react-icons/md';
import { InsightsEvolutieTable } from './InsightsEvolutieTable';
import { BarChartDeltaHighlightAndZoom } from '../../BarChart/BarChartDeltaHighlightAndZoom';
import { BarChartDeltaHighlightAndZoomHorizontal } from '../../BarChart/BarChartDeltaHighlightAndZoomHorizontal';
import { SelectionPanel } from '../InsightsSynthesisSelectionPanel/SelectionMenuComponents/SelectionPanel';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../Tooltip/Tooltip';
import { InfoPanelOther } from '../../InfoPanelCluster/InfoPanelOther';

export const InsightsEvolutie = (props: any) => {
  const {
    data: propsData,
    pathInteractieveTool,
    toggled,
    open,
    setOpen,
    themas,
    indicatorThema,
    gemeenteLijst,
    benchmarkLijst,
    setBenchmarkLijst,
    d_ruimte,
    highlightedRow,
    setHighlightedRow,
    tableHighlightedRow,
    setTableHighlightedRow,
  } = props;
  const {
    selectedGemeente,
    selectedTopic,
    selectedBenchmarks,
    interfaceColor,
    barColors,
    locale,
    isZoomedInsights,
    setIsZoomedInsights,
    zoomFilterIds,
    setZoomFilterIds,
    zoomFilters,
    setZoomFilters,
    deltaColors,
    selectedIndicatorsInzichten,
  } = useData();

  const id = 'Evolutie';

  const [selectedPeriod, setSelectedPeriod] = useState(3);
  const [xVar, setXVar] = useState('deltaMin' + selectedPeriod);
  const yVar = 'displayOrder';

  const [dataTable, setDataTable] = useState(propsData);
  const [resetZoom, setResetZoom] = useState(false);

  const [incomingData, setIncomingData] = useState([]) as any[];
  const [initialState, setInitialState] = useState({
    data: incomingData,
    left: 'dataMin',
    right: 'dataMax',
    refAreaLeft: '',
    refAreaRight: '',
    top: 'dataMax',
    bottom: 'dataMin',
    animation: true,
  }) as any[];

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    toggled && handleOpen();
  }, [toggled]);

  const [zoomGraph, setZoomGraph] = useState(initialState);

  const zoomOut = (pageId: any) => {
    const newTableData = propsData;

    setIsZoomedInsights(false);

    const unique = [...new Set(newTableData.map((d: any) => d.id))];
    setZoomFilters((prev: any) => ({ ...prev, [pageId]: unique }));
    setResetZoom(true);
    setZoomGraph((prev: any) => ({
      ...prev,
      data: newTableData,
      refAreaLeft: '',
      refAreaRight: '',
      left: 'dataMin-1',
      right: 'dataMax+1',
      top: 'dataMax',
      bottom: 'dataMin',
    }));
  };

  const resetData = () => {
    let tmpData = structuredClone(propsData).sort(
      (a: any, b: any) => b[xVar] - a[xVar],
    );

    tmpData.map((d: any, i: number) => {
      d.displayOrder = i + 1;
      return d;
    });

    setInitialState({
      data: tmpData,
      left: 'dataMin',
      right: 'dataMax',
      refAreaLeft: '',
      refAreaRight: '',
      top: 'dataMax+1',
      bottom: 'dataMin-1',
      animation: true,
    });

    setDataTable(propsData);
    setIncomingData(tmpData);
  };

  useEffect(() => {
    resetData();
    zoomOut(id);
  }, [
    propsData,
    setIncomingData,
    setInitialState,
    selectedIndicatorsInzichten,
  ]);

  const onChangeDropdownHandler = (event: any) => {
    event.preventDefault();
    let period = JSON.parse(event.target.value);
    setSelectedPeriod(period);

    const newXVar = 'deltaMin' + period;

    const data = structuredClone(incomingData);
    data.sort(function (a: any, b: any) {
      return b[newXVar] - a[newXVar];
    });

    data.map((d: any, i: number) => {
      d.displayOrder = i + 1;
      return d;
    });

    setIncomingData(data);

    setXVar(newXVar);
    zoomOut(id);
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      setHighlightedRow(null);
      let formattedTick = locale.format(',.1%')(payload[0].value);
      let sign = payload[0].value > 0 ? '+' : '';
      let newValue = sign + formattedTick;

      setTableHighlightedRow(payload[0].payload.id);

      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: 8,
            border: '1px solid #aaa',
            maxWidth: '400px',
          }}
        >
          <p>{payload[0]?.payload?.indicator}</p>
          <ul>
            <li>
              Waarde meest recent:{' '}
              {locale.format(payload[0].payload['d3format']) !== undefined
                ? locale.format(payload[0].payload['d3format'])(
                    payload[0].payload['value'],
                  )
                : payload[0].payload['value']}
            </li>
            <li>
              Waarde {selectedPeriod} jaar eerder:{' '}
              {locale.format(payload[0].payload['d3format']) !== undefined
                ? locale.format(payload[0].payload['d3format'])(
                    payload[0].payload['valueMin' + selectedPeriod],
                  )
                : payload[0].payload['valueMin' + selectedPeriod]}
            </li>
            <li>Relatieve toe-/afname: {newValue}</li>
          </ul>
        </div>
      );
    }
  };

  return (
    <Grid container style={{ padding: '16px' }}>
      <Grid item xs={12}>
        <div
          className={'vl-typography'}
          style={{ paddingLeft: '8rem', float: 'left', width: '70%' }}
        >
          <h4 className="page-title">
            Hoe evolueert {selectedGemeente.label} ten opzichte van vorige
            metingen?{' '}
          </h4>
          <p className="page-subtitle">
            {' '}
            Hoeveel hoger of lager scoort {selectedGemeente.label} op bepaalde
            indicatoren ten opzichte van 3 of 6 jaar geleden?
          </p>
        </div>
        <div
          className={'vl-typography'}
          style={{
            float: 'right',
            // marginLeft: 'auto',
            marginRight: '36px',
            cursor: 'pointer',
            paddingRight: '8px',
            paddingLeft: '8px',
            backgroundColor: interfaceColor,
            borderRadius: 12,
            position: 'relative',
            top: '18px',
          }}
        >
          <p style={{ marginBottom: 0, color: 'white' }} onClick={handleOpen}>
            Pas je selectie aan
          </p>
          <SelectionPanel
            open={open}
            setOpen={setOpen}
            themas={themas}
            indicatorThema={indicatorThema}
            gemeenteLijst={gemeenteLijst}
            selectedGemeente={selectedGemeente}
            selectedBenchmarks={selectedBenchmarks}
            benchmarkLijst={benchmarkLijst}
            setBenchmarkLijst={setBenchmarkLijst}
            d_ruimte={d_ruimte}
          />
        </div>
        <div>
          <InfoPanelOther
            content={
              <>
                <p>
                  Voor elke indicator nemen we voor de gemeente de meest recente
                  meetwaarde en de meetwaarde van 3 jaar en 6 jaar eerder.
                  Vervolgens berekenen we de relatieve toename of afname over
                  deze periode van 3 of 6 jaar. De berekeningen zijn als volgt:
                </p>

                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    <span style={{ color: 'blue' }}>
                      • ( {selectedGemeente.label} (meest recente meetwaarde) -{' '}
                      {selectedGemeente.label} (meetwaarde 3 jaar eerder) ) /{' '}
                      {selectedGemeente.label} (meetwaarde 3 jaar eerder)
                    </span>
                  </li>
                  <li>
                    {' '}
                    <span style={{ color: 'blue' }}>
                      • ( {selectedGemeente.label} (meest recente meetwaarde) -{' '}
                      {selectedGemeente.label} (meetwaarde 6 jaar eerder) ) /{' '}
                      {selectedGemeente.label} (meetwaarde 6 jaar eerder)
                    </span>
                  </li>
                </ul>
                <br />
                <p>
                  Deze figuur toont voor elke indicator hoeveel groter of
                  kleiner de meest recente meetwaarde van{' '}
                  {selectedGemeente.label} is in vergelijking met 3 jaar of 6
                  jaar eerder, relatief uitgedrukt (als percentage). Op die
                  manier kan je voor verschillende indicatoren vlot nagaan hoe{' '}
                  {selectedGemeente.label} evolueert ten opzichte van 3 jaar of
                  6 jaar geleden.
                </p>
                <br />
                <p>Aandachtspunten:</p>
                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    • Voor sommige indicatoren zijn er geen data beschikbaar
                    voor 3 jaar of 6 jaar eerder. Voor deze indicatoren kunnen
                    we bijgevolg geen relatieve toename of afname berekenen. Dit
                    staat ook zo aangegeven in de tabel, en deze indicatoren
                    zijn ook niet zichtbaar in de figuur.
                  </li>
                </ul>
                <br />
                <p>
                  Wil je inzoomen binnen de figuur? Selecteer het gewenste
                  bereik van staafjes/indicatoren. Deze selectie van indicatoren
                  wordt vervolgens ook doorgetrokken naar de andere figuren op
                  de pagina.
                </p>
                <br />
                <p>
                  Wil je de tabel anders sorteren? Je kan de tabel sorteren op
                  elk van de kolommen. Standaard is de tabel gesorteerd op de
                  kolom ‘Relatieve toe-/afname’.
                </p>
              </>
            }
          />
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        pl={5}
        pr={5}
        height={'88vh'}
        minHeight={'400px'}
        maxHeight={'88vh'}
        id={id}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        {incomingData !== undefined && incomingData.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={12}
              sx={{ paddingLeft: '36px', paddingRight: '32px' }}
            >
              <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
                <select
                  name="evolutieSelect"
                  className="vl-select vl-select--block"
                  tabIndex={0}
                  data-vl-select=""
                  data-vl-select-search-empty-text="Geen resultaten gevonden"
                  onChange={onChangeDropdownHandler}
                >
                  <option key={0} value={3} selected={selectedPeriod === 3}>
                    Meest recente meetwaarde versus 3 jaar eerder
                  </option>
                  <option key={1} value={6} selected={selectedPeriod === 6}>
                    Meest recente meetwaarde versus 6 jaar eerder
                  </option>
                </select>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                height: '154px',
                maxHeight: '154px',
                paddingLeft: '36px',
                paddingRight: '36px',
                userSelect: 'none',
                fontSize: '0.8em',
              }}
            >
              <BarChartDeltaHighlightAndZoomHorizontal
                pageId={id}
                xAxisDataKey={xVar}
                yAxisDataKey={yVar}
                incomingData={incomingData}
                initialState={initialState}
                zoomGraph={zoomGraph}
                setZoomGraph={setZoomGraph}
                resetZoom={resetZoom}
                setResetZoom={setResetZoom}
                setIsZoomedInsights={setIsZoomedInsights}
                setDataTable={setDataTable}
                zoomFilters={zoomFilters}
                setZoomFilters={setZoomFilters}
                colors={deltaColors}
                locale={locale}
                CustomTooltip={CustomTooltip}
                highlightedRow={highlightedRow}
                setHighlightedRow={setHighlightedRow}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: '20px',
                maxHeight: '20px',
                paddingRight: '36px',
                paddingLeft: '100px',
              }}
            >
              <div
                style={{
                  whiteSpace: 'break-spaces',
                  fontSize: '13px',
                  paddingRight: '16px',
                }}
              >
                <ul>
                  {Object.keys(zoomFilters).map((d: any) => {
                    if (
                      zoomFilters[d].length !== 0 &&
                      zoomFilters[d].length !== incomingData.length
                    ) {
                      return (
                        <li
                          onClick={() => zoomOut(d)}
                          style={{
                            display: 'inline-block',
                            margin: 4,
                            marginTop: 8,
                            paddingLeft: 8,
                            paddingRight: 14,
                            backgroundColor: interfaceColor,
                            borderRadius: 24,
                            color: 'white',
                            cursor: 'pointer',
                            position: 'relative',
                            top: '-14px',
                          }}
                        >
                          {'Filter ' + d}
                          <span
                            style={{
                              fontWeight: 'bold',
                              position: 'relative',
                              top: 3,
                              left: 8,
                            }}
                          >
                            <MdClose />
                          </span>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                height: '52vh',
                maxHeight: '52vh',
                paddingRight: '36px',
                paddingLeft: '60px',
              }}
            >
              <InsightsEvolutieTable
                data={dataTable}
                pathInteractieveTool={pathInteractieveTool}
                setHighlightedRow={setHighlightedRow}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
                period={selectedPeriod}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              height={'60vh'}
              minHeight={'400px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {' '}
              <p>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
